/* eslint-disable sentence-case/sentence-case */
import React from 'react'
import { RichTextField, SelectInput, useRecordContext } from 'react-admin'
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    DialogContentText,
    Button,
    Typography,
    Box,
} from '@mui/material'
import DOMPurify from 'dompurify'
import { get } from 'lodash-es'
import { DateTimePicker } from '@mui/x-date-pickers'

export const ContentBlock = (props) => {
    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
        // set all links to target=_blank
        if (node.tagName === 'A') {
            node.setAttribute('target', '_blank')
            node.setAttribute('rel', 'noopener')
        }
    })
    return (
        <RichTextField
            {...props}
            sx={{ overflow: 'hidden' }}
            className="pandium-text"
        />
    )
}

export const DisconnectDialog = (props) => {
    const { open, handleClose, connector, disconnect } = props

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs">
            <DialogTitle> {get(connector, 'label', connector.id)} </DialogTitle>
            <DialogContent sx={{ width: '300px' }}>
                <DialogContentText>
                    Are you sure you want to disconnect?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    aria-label={'confirm-disconnect-button'}
                    onClick={() => {
                        disconnect()
                        handleClose()
                    }}
                    sx={{ color: '#fc3b40' }}
                >
                    Disconnect
                </Button>
                <Button onClick={handleClose}> Cancel </Button>
            </DialogActions>
        </Dialog>
    )
}

export const IdField = ({ source }) => {
    const record = useRecordContext()
    try {
        const idArray = get(record, source, '').split('-')
        return (
            <Typography
                variant="body1"
                color="primary"
                sx={{ display: 'flex', flexWrap: 'wrap' }}
            >
                <span style={{ paddingLeft: '2px' }}>
                    {idArray[idArray.length - 1].toUpperCase()}
                </span>
            </Typography>
        )
    } catch {
        return (
            <Typography variant="body1" color={'primary'}>
                {record[source]}
            </Typography>
        )
    }
}

export const FilterSelectInput = (props) => {
    return (
        <SelectInput
            emptyText="Select one"
            {...props}
            variant="outlined"
            sx={(theme) => ({
                padding: 0,
                height: '38px',
                '& > div.MuiInputBase-root': {
                    height: '38px',
                    borderRadius: 3,
                    width: 'auto',
                    '& > div': {
                        fontSize: '13px',
                        fontWeight: 'bold',
                    },
                    '& > fieldset': {
                        border: '2px solid ' + theme.CustomColors.bluegrey,
                    },
                    '&:hover': {
                        '& > fieldset': {
                            borderColor: 'primary.main',
                        },
                    },
                },
                width: '100px',
            })}
        />
    )
}

export const FilterDateTimeInput = ({
    filterValues,
    setFilters,
    source,
    label,
    value,
    setValue,
    minValue,
    maxValue,
    format = 'MMM/DD/YYYY hh:mm A',
}) => {
    const convertedFormat =
        format?.split(' ')[0].toUpperCase() + ' hh:mm A' ?? 'MM/DD/YYYY h:mm A'
    return (
        <DateTimePicker
            disableFuture
            label={label}
            value={value || null}
            onChange={(newValue) => {
                setFilters({
                    ...filterValues,
                    [source]: newValue?.toString(),
                })
                setValue(newValue)
            }}
            minDateTime={minValue}
            maxDateTime={maxValue}
            format={convertedFormat}
            slotProps={{
                textField: {
                    variant: 'outlined',
                    sx: (theme) => ({
                        '& > div.MuiInputBase-root': {
                            height: '38px',
                            borderRadius: 3,
                            width: 'auto',
                            '& > fieldset': {
                                border:
                                    '2px solid ' + theme.CustomColors.bluegrey,
                            },
                            '&:hover': {
                                '& > fieldset': {
                                    borderColor: 'primary.main',
                                },
                            },
                        },
                    }),
                },
            }}
        />
    )
}

export const EmptyState = ({ emptyStateText }) => {
    return (
        <Box
            sx={{
                margin: 8,
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            <Box sx={{ fontSize: '20px' }}>{emptyStateText}</Box>
        </Box>
    )
}
